var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMeter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.2058 14.479C28.263 14.9612 28.2948 15.4528 28.2948 15.9524C28.2948 22.7294 22.7943 28.2248 16.0077 28.2248C11.0661 28.2248 6.80739 25.3113 4.85585 21.1101L6.82168 20.122C8.40956 23.6064 11.9252 26.0282 16.0077 26.0282C21.578 26.0282 26.0955 21.5177 26.0955 15.9524C26.0955 15.8493 26.0939 15.7462 26.0908 15.6431L28.2058 14.479ZM16.0077 3.68C21.1826 3.68 25.6112 6.87579 27.4214 11.4006L25.319 12.0699C23.7979 8.4332 20.2013 5.87661 16.0077 5.87661C10.4373 5.87661 5.91977 10.3871 5.91977 15.9524C5.91977 16.0206 5.92133 16.0904 5.92292 16.1586L3.86502 17.8397C3.76975 17.2244 3.72052 16.5947 3.72052 15.9524C3.72211 9.17389 9.22258 3.68 16.0077 3.68Z",
    fill: "#010F36"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.32001 20.8595L14.3372 11.0422L13.8386 15.1245L20.8523 11.1548L20.4966 15.0309L29.6969 12.1048L17.2192 18.969L18.1513 15.0627L10.9423 19.283L11.4186 16.2871L2.32001 20.8595Z",
    fill: "#010F36"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeter);
export default __webpack_public_path__ + "static/media/meter.7033b5e7f97081919ae451a882447899.svg";
export { ForwardRef as ReactComponent };